import {
    TrendingDown,
    TrendingUp,
} from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
    Card,
    CardAction,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface StatCardProps {
    title: string;
    value: string | number;
    /** Delta value already formatted, e.g. "12.5%" or "24". */
    delta?: string;
    /** Context for the delta, e.g. "vs last month". */
    deltaNote?: string;
    positive?: boolean;
    prefix?: string;
}

export function StatCard({
    title,
    value,
    delta,
    deltaNote,
    positive = true,
    prefix = '',
}: StatCardProps) {
    const TrendIcon = positive ? TrendingUp : TrendingDown;
    const formatted = typeof value === 'number'
        ? value.toLocaleString()
        : value;

    return (
        <Card className="gap-3 py-5">
            <CardHeader className="px-5">
                <CardDescription className="text-xs">{title}</CardDescription>
                <CardTitle className="text-2xl font-semibold tabular-nums">
                    {prefix}
                    {formatted}
                </CardTitle>
                {delta && (
                    <CardAction>
                        <Badge
                            variant="outline"
                            className={cn(
                                'gap-1 rounded-md px-1.5 py-0.5 font-medium tabular-nums',
                                positive
                                    ? 'text-success'
                                    : 'text-destructive',
                            )}
                        >
                            <TrendIcon className="size-3" />
                            {delta}
                        </Badge>
                    </CardAction>
                )}
            </CardHeader>
            {deltaNote && (
                <CardFooter className="px-5 text-xs text-muted-foreground">
                    {deltaNote}
                </CardFooter>
            )}
        </Card>
    );
}
